import React, { useRef, useState } from 'react';
import axios from 'axios';
import { toast } from '../components/ui/sonner';

const EMPTY_FORM = { name: '', email: '', phone: '', service: '', message: '' };
const FIELD_ERRORS = {
  name: 'Le nom doit contenir entre 2 et 150 caractères.',
  email: 'Veuillez saisir une adresse email valide.',
  phone: 'Le téléphone ne doit pas dépasser 40 caractères.',
  service: 'Veuillez sélectionner un service proposé.',
  message: 'Le message doit contenir entre 10 et 5 000 caractères.'
};

const getErrorMessage = (error) => {
  const detail = error.response?.data?.detail;
  if (Array.isArray(detail)) {
    return [...new Set(detail.map(item => FIELD_ERRORS[item?.loc?.[1]] ||
      'Veuillez vérifier les informations saisies.'))].join(' ');
  }
  if (typeof detail === 'string') return detail;
  if (!error.response) {
    return "L’envoi n’a pas pu être confirmé. Vérifiez votre connexion avant de réessayer.";
  }
  return 'Une erreur est survenue. Veuillez réessayer.';
};

export const useContactForm = () => {
  const [formData, setFormData] = useState(EMPTY_FORM);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [feedback, setFeedback] = useState(null);
  const inFlight = useRef(false);

  const handleChange = ({ target: { name, value } }) => {
    setFormData(previous => ({ ...previous, [name]: value }));
    setFeedback(null);
  };

  const notifyError = (message) => {
    setFeedback({ type: 'error', message });
    toast.error(<span data-testid="contact-error-toast">{message}</span>, { id: 'contact-feedback' });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (inFlight.current) return;
    const payload = Object.fromEntries(Object.entries(formData).map(([key, value]) => [key, value.trim()]));
    if (payload.name.length < 2 || payload.message.length < 10) {
      notifyError(payload.name.length < 2 ? FIELD_ERRORS.name : FIELD_ERRORS.message);
      return;
    }
    inFlight.current = true;
    setIsSubmitting(true);
    setFeedback(null);
    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/contact`, payload, { timeout: 15000 });
      const message = 'Votre demande a bien été enregistrée. Nous vous recontacterons dans les plus brefs délais.';
      setFeedback({ type: 'success', message });
      toast.success(<span data-testid="contact-success-toast">Message envoyé !</span>, {
        id: 'contact-feedback', description: message
      });
      setFormData(EMPTY_FORM);
    } catch (error) {
      notifyError(getErrorMessage(error));
    } finally {
      inFlight.current = false;
      setIsSubmitting(false);
    }
  };

  return { formData, isSubmitting, feedback, handleChange, handleSubmit };
};